/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Modal,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import {
  deleteCouponCode,
  searchLeadForOrder,
  is_featured_status_change,
  CouponHolderList,
  searchCouponCode,
  AssignCoupon,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";

import SweetAlert from "react-bootstrap-sweetalert";

import Switch from "react-bootstrap-switch";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { style } from "../../../variables/Variables";
class viewCouponCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponcode_detail: [],
      couponcode_category_detail: [],
      category: [],
      couponHolders: [],
      category_name: "",
      itemcode: "",
      title: "",
      couponcodecategory: "",
      price: "",
      commision: "",
      unitprice: "",
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      subscriberItems: [],
      loading: false,
      p_couponid: null,
      tabledata: [],
      page: "",
      _notificationSystem: null,
      alert: null,
      useraccess: "",
      couponcodefile: null,
      city: "0",
      showbulkui: 0,
      noRecordFound: false,
      is_flash_medicine: "",
      is_featured: "",
      city_info: [],
      subscriber: [],
      codeDisabled: "",
      is_all_customers: "",
      processing_msg: "",
    };
    this.fileInput = React.createRef();
    this.submitbulkcouponcode = this.submitbulkcouponcode.bind(this);
    this.selectedcouponcode = this.selectedcouponcode.bind(this);
    this.deletemedicaton = this.deletemedicaton.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.addbulkcouponcode = this.addbulkcouponcode.bind(this);
    // this.onChange = this.onChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
    this.inputOnChangeSubscriber = this.inputOnChangeSubscriber.bind(this);
  }
  selectedcouponcode(cus) {
    // console.log(cus);
    localStorage.setItem("couponcodeID", JSON.stringify(cus));

    this.props.history.push("/admin/edit_couponcode");
  }
  sendToParentSubscriber = async () => {
    //this.props.searching(this.state.name);c
    // alert("==="+this.state.name.trim()+"===")
    if (this.state.subscribername.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var city_id = this.state.city_id;
      await searchLeadForOrder(this.state.subscribername, obj).then((res) => {
        const data = res.data.data;
        let subscriberItems = [];
        res.data.data.map((x, i) => {
          subscriberItems.push({
            value: x.id,
            label: x.name + " (" + x.mobile_no + ")",
          });
        });

        this.setState({
          subscriber_detail: data,
          subscriberItems: subscriberItems,
        });
      });
    } else {
      this.setState({
        subscriberItems: [],
        subscriber_detail: [],
      });
    }
  };
  inputOnChangeSubscriber = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      subscribername: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParentSubscriber(self.state.subscribername);
      }, 300),
    });
  };
  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.searchData();
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });

    let pg_no = 1;
    var country_id = "1";
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    this.searchdata();
  };
  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }
  resetSearch(e) {
    this.setState({
      itemcode: "",
      title: "",
      couponcodecategory: "",
      price: "",
      commision: "",
      unitprice: "",
      city: "0",
    });
    this.searchData();
  }
  subStrAfterChars(str, char, pos) {
    if (pos == "b") return str.substring(str.indexOf(char) + 1);
    else if (pos == "a") return str.substring(0, str.indexOf(char));
    else return str;
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({ noRecordFound: false });

    // console.log(this.state.itemcode,this.state.description,this.state.price,this.state.couponcodecategory,this.state.commision,this.state.unitprice,this.state.page)
    this.setState({ loading: true }, () => {
      searchCouponCode(this.state.page, obj)
        .then((response1) => {
          var data = response1.data;
          var couponcode_category = data.data;
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          // console.log(data.next_page_url);
          // console.log(data,data.last_page);
          var $no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            } else {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            } else {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });

          this.setState({
            loading: false,
            tabledata: data.data,
            couponcode_category_detail: couponcode_category,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    });
  }
  closeCancelModal() {
    this.setState({ showCouponModal: false });
  }
  closeCancelassignModal() {
    this.setState({ showCouponHolderModal: false });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletemedicaton(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this couponcode Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  addbulkcouponcode() {
    this.setState({
      showbulkui: 1,
    });
  }
  closemedicatonupload() {
    this.setState({
      showbulkui: 0,
    });
  }

  is_feature_change(id, feature) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var is_featured = "";
    if (feature == "1") {
      is_featured = 0;
    } else if (feature == "0") {
      is_featured = 1;
    }
    is_featured_status_change(is_featured, id, obj).then((res) => {
      if (res.data.success == true) {
        this.searchData();
      }
    });
  }
  handleInputChange(event) {
    // let file = event.target.files[0]
    // console.log(file)
    // this.setState({ couponcodefile: event.target.files[0] });
    // this.setState({
    //   couponcodefile: file
    //   })
  }
  submitbulkcouponcode() {
    // var token = JSON.parse(localStorage.getItem('user'));
    // const  obj = token.token
    // const file_data = this.state.couponcodefile;
    // console.log(file_data,'file data')
    // const data = new FormData();
    // data.append('myFile',file_data)
    // // alert(`selected file - ${this.fileInput.current.files[0]}`)
    // // console.log(formdata)
    // Addcouponcodebulkfile(data,obj)
    // .then((res)=>{
    //     alert(res);
    // })
    // .then(error => {
    //   console.log(error)
    // })
  }
  couponHolder(coupon_id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;

    CouponHolderList(coupon_id, obj)
      .then((response) => {
        console.log(response.data, "coupon holder");
        this.setState({
          couponHolders: response.data,
          showCouponHolderModal: true,
        });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  assignCustomer = async (coupon_id) => {
    var tag = [];
    this.state.subscriber.map((data) => {
      var array1 = tag;
      var array2 = array1.concat(data.value);
      tag = array2;
    });
    console.log(tag, "coupons ");
    console.log(this.state.p_couponid, "coupon id");
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    var all = this.state.is_all_customers;
    if (this.state.is_all_customers) {
      tag = [];
      all = 1;
    } else {
      all = 0;
    }
    var processing_msg = "Please wait we are processing...";
    this.setState({ processing_msg: processing_msg });
    await AssignCoupon(tag, all, this.state.p_couponid, obj)
      .then(() => {
        this.setState({
          showCouponModal: false,
        });
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  };
  assignCoupon(id) {
    this.setState({
      processing_msg: "",
      showCouponModal: true,
      p_couponid: id,
    });
  }
  deletemedicaton(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;

    deleteCouponCode(id, obj)
      .then(() => {
        // alert('category deleted');
        // window.location.href="#/admin/couponcode-category";
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  addcouponcode() {
    this.props.history.push("/admin/addcoupon");
  }

  onSubscriberChange = (value) => {
    this.setState({
      subscriber: value,
    });
  };
  isAllCustomers = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    this.setState({ is_all_customers: checked });
  };

  render() {
    const change_status = (
      <Tooltip id="change_status">Change Feature Status</Tooltip>
    );

    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const assign = <Tooltip id="payment">Assign to user</Tooltip>;
    const couponowner = <Tooltip id="couponowner">Assigned to</Tooltip>;
    const couponcode = this.state.tabledata;
    // console.log(couponcode_detail);
    // const couponcode_category_detail =  couponcode.map(med=>{
    //   med.couponcode_category.map(cat=>{
    //    <td> {cat.category_name}</td>
    //   })
    // })
    // console.log(couponcode_category_detail)
    var c = 1;
    // console.log(couponcode);
    // const couponcodecat = category.map((cat)=>{
    //   {cat.id}
    //   // ':' ;{cat.catgory_name}
    // })
    const add_Commisson_array = { 1: "Yes", 0: "No" };

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    {this.state.useraccess == 8 ? (
                      ""
                    ) : (
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          className="text-right"
                        >
                          <Button
                            className="fl_mb_web_1 btn-fill fl_mb_1 w_150 "
                            class="btn-color" //bsStyle="info" fill
                            style={{ width: "165px" }}
                            onClick={this.addcouponcode.bind(this)}
                          >
                            Add Coupon Code <i className="fa fa-plus"></i>
                          </Button>
                          <br />
                          &nbsp;
                          {/* <Button  className="fl_mb_web_1 btn-fill fl_mb_1 w_150 " onClick={this.addbulkcouponcode.bind(this)}  bsStyle="info" fill  >Add Bulk couponcode</Button> */}
                        </Col>

                        {/* {this.state.showbulkui == 1 ? 
                    <Col xs={12} sm={12} md={12} lg={12} > 
                    <h5>Upload couponcode details</h5>
                    <form>
                      <FormGroup>
                      <ControlLabel>Bulk couponcode</ControlLabel>
                      <input type="file"  name="couponcodefile" onChange={this.handleInputChange}  placeholder="select file" />
                      </FormGroup>
                      <FormGroup>
                        <Button fill onClick={this.submitbulkcouponcode.bind(this)} bsStyle="success">Submit</Button>
                        &nbsp;
                        <Button fill  onClick={this.closemedicatonupload.bind(this)} bsStyle="danger">close</Button>
                        &nbsp;
                        <Button fill  onClick={this.exportfile.bind(this)} bsStyle="danger">export</Button>
                        
                      </FormGroup>
                    </form>
                    </Col>
                    : ''} */}
                      </Col>
                    )}
                    <br />
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Coupon Code</th>
                            <th>Title</th>
                            <th>Partner</th>
                            <th>Discount</th>
                            <th>Usage Limit</th>
                            <th>Usage Per cutsomer</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            {this.state.useraccess == 1 && (
                              <th className="text-right">Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {couponcode.map((cus) => (
                                <tr>
                                  <td>{cus.coupon_code}</td>
                                  <td>{cus.title}</td>
                                  <td>
                                    {cus.partner_id != ""
                                      ? cus.partner.name
                                      : ""}
                                  </td>
                                  <td>
                                    {cus.discount}
                                    {cus.discount_type == 1 ? "" : "%"}
                                  </td>
                                  <td>{cus.usage_limit}</td>
                                  <td>{cus.usage_per_customer}</td>
                                  <td>{cus.start_date}</td>
                                  <td>{cus.end_date}</td>
                                  {this.state.useraccess == 4 ||
                                  this.state.useraccess == 6 ||
                                  this.state.useraccess == 7 ||
                                  this.state.useraccess == 8 ||
                                  this.state.useraccess == 9 ||
                                  this.state.useraccess == 10 ? (
                                    ""
                                  ) : (
                                    <td className="td-actions text-right no-padding">
                                      {/* <OverlayTrigger
                                        placement="top"
                                        overlay={change_status}
                                      >
                                        <Button
                                          simple
                                          bsStyle="info"
                                          onClick={this.is_feature_change.bind(
                                            this,
                                            cus.id,
                                            cus.is_featured
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-check-square-o" />
                                        </Button>
                                      </OverlayTrigger>
                                      */}
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.selectedcouponcode.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        placement="top"
                                        overlay={couponowner}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.couponHolder.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-id-badge" />
                                        </Button>
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={assign}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.assignCoupon.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-share" />
                                        </Button>
                                      </OverlayTrigger>
                                      {this.state.useraccess == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                              this,
                                              cus.id
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              dataUrl={this.state.prevpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                dataUrl={url}
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              dataUrl={this.state.nextpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                    </Col>

                    <Modal
                      show={this.state.showCouponHolderModal}
                      onHide={() =>
                        this.setState({ showCouponHolderModal: true })
                      }
                    >
                      <Modal.Header>
                        <Modal.Title>Assigned To ...</Modal.Title>
                      </Modal.Header>
                      <Modal.Body
                        style={{ maxHeight: "350px", overflowY: "auto" }}
                      >
                        <FormGroup>
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Mobile No.</th>
                                <th>is used?</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.couponHolders.map((cus) => (
                                <tr>
                                  <td> {cus.lead.name}</td>
                                  <td>{cus.lead.mobile_no}</td>
                                  <td>{cus.is_used == 1 ? "Yes" : "No"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </FormGroup>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={this.closeCancelassignModal.bind(this)}
                          bsStyle="info"
                          fill
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={this.state.showCouponModal}
                      onHide={() => this.setState({ showCouponModal: true })}
                    >
                      <Modal.Header>
                        <Modal.Title>Assign Coupon</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <FormGroup>
                          <Checkbox
                            number="49"
                            checked={this.state.is_all_customers}
                            onChange={(e) => this.isAllCustomers(e)}
                            label="Is coupon assign to all customers?"
                          ></Checkbox>
                        </FormGroup>
                        {this.state.processing_msg}
                        <FormGroup
                          style={{
                            display: this.state.codeDisabled ? "none" : "block",
                          }}
                        >
                          <ControlLabel>Select Customer</ControlLabel>
                          <div
                            onKeyUp={(e) => this.inputOnChangeSubscriber(e)}
                            className="Appy2"
                            style={{ textTransform: "capitalize" }}
                          >
                            <Select
                              style={{ textTransform: "capitalize" }}
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="subscriber"
                              value={this.state.healthcondition}
                              onChange={(value) =>
                                this.onSubscriberChange(value)
                              }
                              isMulti
                              options={this.state.subscriberItems}
                              placeholder="Subscriber"
                              noOptionsMessage={() =>
                                "Type Name or Phone Number"
                              }
                            />
                          </div>
                          {this.state.assigncutomerError}
                        </FormGroup>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={this.assignCustomer.bind(this)}
                          bsStyle="success"
                          fill
                        >
                          Submit
                        </Button>
                        &nbsp;
                        <Button
                          onClick={this.closeCancelModal.bind(this)}
                          bsStyle="info"
                          fill
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(viewCouponCode);
